import { Colors } from '@src/colors';
import styled from 'styled-components';

export const Option = styled.li`
    font-family: Public Sans;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: left;

    &:hover {
        background: ${Colors.midnight2};
    }
    &:focus {
        background: ${Colors.midnight2};
        outline: -webkit-focus-ring-color auto 1px;
    }
    &:active {
        background: ${Colors.midnight4};
    }
`;
